import { useAuthSessionManager } from '@/hooks/useAuthSessionManager';
import { useSessionValidator } from '@/hooks/useSessionValidator';

/**
 * Component that handles session management globally.
 * Should be placed inside BrowserRouter but as a sibling to Routes.
 */
export function SessionManager() {
  // Manage session creation on auth state changes
  useAuthSessionManager();
  
  // Validate session and handle real-time invalidation
  useSessionValidator();

  return null; // This component doesn't render anything
}
